import { useLingui } from '@lingui/react/macro';
import { Header } from './header';
import { Layout } from './layout';
import { Seo } from '@/routes/-components/seo';
import { diamondGlows, DiamondGrid, Eyebrow, PillLink } from './primitives';
import { NewPathsIllustration } from '@worldcoo/ui/illustrations/static/new-paths';

/**
 * Rendered by the `/new/$` catch-all and the group's `notFoundComponent`. No footer, as the hand-off
 * draws it, so nothing buries the two links back.
 */
export function NotFoundPage() {
	const { t } = useLingui();
	return (
		<Layout>
			<Header />
			{/* `noindex` too, for a crawler that ignores the HTTP 404 (new/$.tsx). */}
			<Seo title={t`Page not found - Worldcoo`} noindex />
			<section className="mx-auto grid max-w-[1440px] items-center gap-6 px-6 pt-6 pb-16 md:pb-24 lg:grid-cols-2 xl:px-8">
				<div className="bg-sage relative aspect-[676/629] overflow-hidden rounded-3xl">
					{/* The centre of the hand-off's own gradient. */}
					<DiamondGrid
						color="#35433F"
						opacity={1}
						size={4.39}
						gap={27.59}
						masks={[diamondGlows({ x: '7.2%', y: '97.2%' })]}
					/>
					{/* Drawn at the card's 676x629 viewBox, so it scales with the card without offsets. */}
					<NewPathsIllustration
						frame="scene"
						label={t`An open folder with two butterflies flying out of it`}
						className="absolute inset-0 size-full"
					/>
				</div>

				<div className="flex flex-col items-start gap-6 lg:mx-auto lg:max-w-[486px]">
					<Eyebrow>404</Eyebrow>
					<h1 className="text-4xl leading-[1.14] font-medium tracking-[-0.02em] md:text-[48px]">
						{t`It looks like this page got lost.`}
					</h1>
					<p className="text-ink/70 leading-[1.5]">
						{t`The page you are looking for is not available. We invite you to carry on discovering how small actions can add up to big change.`}
					</p>
					<div className="flex flex-wrap gap-3">
						<PillLink variant="ink" to="/www/solutions">
							{t`Solutions`}
						</PillLink>
						<PillLink variant="ink" to="/www/partner-ngos">
							{t`Partner NGOs`}
						</PillLink>
					</div>
				</div>
			</section>
		</Layout>
	);
}
